<div class="question-container">
       <label [innerHTML]="label" [class.required]="isRequired && label" ></label>
    
<mat-form-field appearance="outline" class="full-width" [ngClass]="{'m-b-1': showError && errorMessages.length}">
   
  <textarea matInput rows="5"  [formControl]="control" [placeholder]="placeholder" maxlength="1000"></textarea>
  @if (showError && errorMessages.length) {
    
      <mat-error>
        @for (msg of errorMessages; track msg) {
          {{ msg }}
        }
      </mat-error>
  }
</mat-form-field>
</div>